import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import { MainLayout } from './layouts';
import { HomePage } from './features/home';
import { AboutPage } from './features/about';
import { ContactPage } from './features/contact';
import { AppLauncherPage } from './features/app-launcher';
import { MovingMotivatorsHome, CreateRoom, JoinRoom, Play } from './apps/moving-motivators';
import {
  DelegationPokerHome,
  CreateRoom as DPCreateRoom,
  JoinRoom as DPJoinRoom,
  Room as DPRoom,
} from './apps/delegation-poker';
import {
  PlanningPokerHome,
  CreateRoom as PPCreateRoom,
  JoinRoom as PPJoinRoom,
  Room as PPRoom,
} from './apps/planning-poker';
import {
  KanbanBoardHome,
  CreateRoom as KBCreateRoom,
  JoinRoom as KBJoinRoom,
  Room as KBRoom,
} from './apps/kanban-board';

export const router = createBrowserRouter([
  {
    path: '/',
    element: <MainLayout />,
    children: [
      {
        index: true,
        element: <HomePage />,
      },
      {
        path: 'about',
        element: <AboutPage />,
      },
      {
        path: 'contact',
        element: <ContactPage />,
      },
      {
        path: 'apps',
        element: <AppLauncherPage />,
      },
      {
        path: 'apps/moving-motivators',
        element: <MovingMotivatorsHome />,
      },
      {
        path: 'apps/moving-motivators/create-room',
        element: <CreateRoom />,
      },
      {
        path: 'apps/moving-motivators/join-room',
        element: <JoinRoom />,
      },
      {
        path: 'apps/moving-motivators/play/:roomId',
        element: <Play />,
      },
      {
        path: 'apps/delegation-poker',
        element: <DelegationPokerHome />,
      },
      {
        path: 'apps/delegation-poker/create',
        element: <DPCreateRoom />,
      },
      {
        path: 'apps/delegation-poker/join',
        element: <DPJoinRoom />,
      },
      {
        path: 'apps/delegation-poker/room/:roomId',
        element: <DPRoom />,
      },
      {
        path: 'apps/planning-poker',
        element: <PlanningPokerHome />,
      },
      {
        path: 'apps/planning-poker/create',
        element: <PPCreateRoom />,
      },
      {
        path: 'apps/planning-poker/join',
        element: <PPJoinRoom />,
      },
      {
        path: 'apps/planning-poker/room/:roomId',
        element: <PPRoom />,
      },
      {
        path: 'apps/kanban-board',
        element: <KanbanBoardHome />,
      },
      {
        path: 'apps/kanban-board/create',
        element: <KBCreateRoom />,
      },
      {
        path: 'apps/kanban-board/join',
        element: <KBJoinRoom />,
      },
      {
        path: 'apps/kanban-board/room/:roomId',
        element: <KBRoom />,
      },
    ],
  },
]);

export const AppRouter = () => {
  return <RouterProvider router={router} />;
};
